/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Left Accordion List Styles
 *
 * @file LeftAccordionListStyle.jsx
 * @author Murhsid Ahamedh
 */

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import DoneIcon from '@mui/icons-material/Done';
import mixins from '../../../../assets/styles/mixins.scss';

export const CARD_SIDE_PADDING = 12; // matches CustomAccordion card padding

export const LeftAccordionContainer = styled('ul')({
  '&&': {
    listStyle: 'none',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    padding: 16,

    [mixins['mlg-min']]: {
      padding: 0
    }
  }
});

export const LeftAccordionSectionItem = styled('li')({
  '&&': {
    listStyle: 'none',
    display: 'block',
    width: '100%'
  }
});

export const LeftAccordionItemRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected'
})(({ isSelected }) => ({
  '&&': {
    color: '#2E2E2E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: isSelected ? '8px 24px' : '8px 12px',
    borderRadius: 0,
    ...(isSelected ? {
      background: '#E8E6F3',
      marginLeft: -CARD_SIDE_PADDING,
      marginRight: -CARD_SIDE_PADDING
    } : {})
  }
}));

export const LeftAccordionTopicText = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected'
})(({ isSelected }) => ({
  '&&': {
    color: '#2E2E2E',
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: isSelected ? mixins.fontWeight600 : mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight150,
    letterSpacing: '0',
    flex: 1,
    minWidth: 0,
    cursor: 'pointer',
    textAlign: 'left',
    background: 'none',
    border: 'none',
    padding: 0
  }
}));

export const LeftAccordionDoneIcon = styled(DoneIcon)({
  '&&': {
    transform: 'rotate(0deg)',
    opacity: 1,
    fontSize: 28,
    color: '#2E2E2E'
  }
});

export const LeftAccordionTopicsList = styled(Box)({
  '&&': {
    listStyle: 'none',
    margin: 0,
    padding: '12px 0 0 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  }
});

export const LeftAccordionEmptyState = styled(Box)({
  '&&': {
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#9CA3AF',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight150
  }
});
